import React from 'react';
import LegalPageLayout from './LegalPageLayout';

export default function LegalIndex() {
  return (
    <LegalPageLayout>
      <div className="space-y-16 text-center py-20">
        <h1 className="text-4xl font-extrabold text-purple-300">
          Million2Trillion — Legal Center
        </h1>
        <p className="text-lg text-gray-300">
          Please select any legal policy from the sidebar to view full details.
        </p>
      </div>
    </LegalPageLayout>
  );
}
